import React from "react";
import { Box as ChakraBox, BoxProps, forwardRef } from "@chakra-ui/react";

export const Box = forwardRef((props: BoxProps, ref) => {
  return <ChakraBox ref={ref} fontFamily="body" {...props} />;
});
